import { jsxs as i, jsx as e } from "react/jsx-runtime";
import * as r from "@radix-ui/react-collapsible";
import { useCallback as m } from "react";
import { useDatePicker as d } from "./index.es851.js";
import { onKeyDownEsc as f } from "./index.es528.js";
import { FlexContainer as l } from "./index.es584.js";
import { BodyText as C } from "./index.es505.js";
import { UtilityChevronIcon as y } from "./index.es439.js";
const w = ({ children: s, label: a, ...n }) => {
  const { setCollapsedIsOpen: o, collapsedIsOpen: t } = d(), p = m(
    (c) => f(c, () => o(!1), !1),
    [o]
  );
  return /* @__PURE__ */ i(
    r.Root,
    {
      onOpenChange: o,
      open: t,
      onKeyDown: p,
      children: [
        /* @__PURE__ */ e(r.Trigger, { children: /* @__PURE__ */ i(
          l,
          {
            justifyContent: "spaceBetween",
            gap: 8,
            alignItems: "center",
            style: { cursor: "pointer" },
            aria: { "aria-label": "Select Date", ...n },
            ...n,
            children: [
              /* @__PURE__ */ e(C, { size: "default", variant: "semi-bold", children: a }),
              /* @__PURE__ */ e(l, { alignItems: "center", children: /* @__PURE__ */ e(
                y,
                {
                  direction: t ? "up" : "down",
                  type: "bold"
                }
              ) })
            ]
          }
        ) }),
        /* @__PURE__ */ e(r.Content, { children: s })
      ]
    }
  );
};
export {
  w as DatePickerCollapsed
};
//# sourceMappingURL=index.es853.js.map
